import { createFileRoute } from '@tanstack/react-router';
import { PlatformBrandingEditor } from '../../pages/platform/branding/PlatformBrandingEditor';

// Pestaña Branding del drill-down. El tenantId sale del PATH (no del user logueado) y se pasa por prop al
// editor, que consume platformApi.getTenantBranding/updateTenantBranding sobre ESE tenant. El acceso ya
// está gateado por `tenant.branding.manage` scope TENANT/tenantId en el sub-nav del shell ($tenantId.tsx).
export const Route = createFileRoute('/_authenticated/_layout/platform/tenants/$tenantId/branding')(
    {
        component: TenantBranding,
    },
);

function TenantBranding() {
    const { tenantId } = Route.useParams();
    return <PlatformBrandingEditor tenantId={tenantId} />;
}
